import StackedPieChart from "./../../../../components/stackedPieChart/stackedPieChart";
import {connect} from "react-redux";

export default connect(state => ({
  data: state.studioInfo.salesActivityRevenue.chartInfo.data,
  width: 650,
  isCurrency: true,
  hideLegendMetrics: true,
  chartStats: [
    {
      title: "Net Revenue",
      value: state.studioInfo.salesActivityRevenue.summaryInfo.revenue,
      valueRawDataLink: state.studioInfo.salesActivityRevenue.summaryInfo.revenueRawDataLink,
      percentChange: state.studioInfo.salesActivityRevenue.summaryInfo.change
    }
  ]
}))(StackedPieChart);
